import React from 'react';
import { I18n } from 'aws-amplify';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TeamMemberHelp } from './TeamMemberHelp';
import { GlobalHelp } from './GlobalHelp';
import { helpInformations, helpInstallation, helpManageInstallation, helpManageTournee, helpTournee } from './ScrbHelp';

const TeamHelp = () => {
    return (<>
        <h3>{I18n.get("Gérer mon équipe")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <span className='pi pi-video mr-2' style={{ fontWeight: "bold" }}></span><a style={{ color: '#000000' }} href={I18n.get("https://www.cdm.lu/mediatheque/media/comment-gerer-mon-equipe")} rel="noopener noreferrer" target="_blank">{I18n.get("Vidéo explicative")}</a>
        <div>
            <div className="grid">
                <div className="col"><b></b></div>
            </div>
            <div className="grid">
                <div className="col"><b>{I18n.get("Actions possibles")}:</b></div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="pi pi-user-plus" className="p-mr-2" /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("Ajouter des nouveaux membres à votre équipe")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="pi pi-user-edit" className="p-button-rounded p-button-success p-button-outlined mr-2" /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("Modifier les membres de votre équipe")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div><Button icon="fas fa-user-check" className="p-button-rounded p-button-success p-button-outlined p-mr-2" /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("Activer l'accès des membres de votre équipe")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div> <Button icon="fas fa-user-slash" className="p-button-rounded p-button-danger p-button-outlined p-mr-2" /></div>
                <div className="col cdm-col-no-top-padding">{I18n.get("Désactiver l'accès des membres de votre équipe")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col"><b>{I18n.get("Données affichées")}:</b></div>
            </div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col">
                    <DataTable emptyMessage={I18n.get("Le nom utilisé pour se connecter")} size="small" responsiveLayout="scroll">
                        <Column
                            header={I18n.get("Nom d'utilisateur")}
                            sortable
                        />
                    </DataTable>
                </div>
            </div>
            <div className="grid">
                <div className="col">
                    <DataTable emptyMessage={I18n.get("Le nom de l'utilisateur")} size="small" responsiveLayout="scroll">
                        <Column
                            header={I18n.get("Nom")}
                            sortable
                        />
                    </DataTable>
                </div>
            </div>
            <div className="grid">
                <div className="col">
                    <DataTable emptyMessage={I18n.get("Le prénom de l'utilisateur")} size="small" responsiveLayout="scroll">
                        <Column
                            header={I18n.get("Prénom")}
                            sortable
                        />
                    </DataTable>
                </div>
            </div>
            <div className="grid">
                <div className="col">
                    <DataTable emptyMessage={I18n.get("Statut du compte de l'utilisateur")} size="small" responsiveLayout="scroll">
                        <Column
                            header={I18n.get("Statut")}
                            sortable
                        />
                    </DataTable>
                </div>
            </div>
            <div className="grid">
                <div className="col">
                    <DataTable emptyMessage={I18n.get("Le rôle joué par l'utilisateur")} size="small" responsiveLayout="scroll">
                        <Column
                            header={I18n.get("Rôles")}
                            sortable
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    </>
    )
};

export const Help = {
    team: 'team',
    teammember: 'teammember',
    global: 'global',
    installation: 'installation',
    manageInstallation: 'manageInstallation',
    informations: 'informations',
    tournee: 'tournee',
    manageTournee: 'manageTournee',
}

export const HelpComponent = {
    team: TeamHelp,
    teammember: TeamMemberHelp,
    global: GlobalHelp,
    installation: helpInstallation,
    manageInstallation: helpManageInstallation,
    informations: helpInformations,
    tournee: helpTournee,
    manageTournee: helpManageTournee,
};
